import { Fragment, ReactElement } from 'react';

import StickyButton from 'chime-ui/components/StickyButton';
import { SmallTitle, StandardText } from 'chime-ui/components/Typography';

import { MachineContext, useMachineContext } from 'hooks/useMachineContext';
import { useUserContext } from 'hooks/useUserContext';

import ErrorGeneric from './Generic';

type ClaimFlowProps = {
  showLogin?: boolean;
  showCta?: boolean;
};

function ErrorContextual({
  showLogin = true,
  showCta = true,
}: ClaimFlowProps): ReactElement {
  const [userData] = useUserContext();
  const [state] = useMachineContext(MachineContext);
  const { context } = state;

  if (!context.error?.id) return <ErrorGeneric />;

  const CTAComponent = () =>
    context.error.id === 'claimed_from_expired_status' ? (
      <StickyButton
        as="a"
        href={`${process.env.MARKETING_HOST}/r/${userData.referralToken}`}
      >
        Join Chime
      </StickyButton>
    ) : (
      <StickyButton
        as="a"
        href="https://help.chime.com/hc/en-us/articles/23918862092567-How-can-I-troubleshoot-issues-with-claiming-Pay-Anyone-Transfers-if-I-m-not-a-Chime-member"
      >
        Get help
      </StickyButton>
    );

  return (
    <ErrorGeneric cta={showCta ? <CTAComponent /> : null} showLogin={showLogin}>
      <SmallTitle>{context.error.header}</SmallTitle>
      {context.error.body.split('\n').map((text, index) => (
        <Fragment key={`error${index}`}>
          <StandardText>{text}</StandardText>
          <br />
        </Fragment>
      ))}
    </ErrorGeneric>
  );
}

export default ErrorContextual;
